export function crop(url, aspectRatio) {
  return new Promise(resolve => {
    const inputImage = new Image();
    inputImage.onload = () => {
      const inputWidth = inputImage.naturalWidth;
      const inputHeight = inputImage.naturalHeight;

      const inputImageAspectRatio = inputWidth / inputHeight;

      let outputWidth = inputWidth;
      let outputHeight = inputHeight;
      if (inputImageAspectRatio > aspectRatio) {
        outputWidth = inputHeight * aspectRatio;
      } else if (inputImageAspectRatio < aspectRatio) {
        outputHeight = inputWidth / aspectRatio;
      }

      const outputX = (outputWidth - inputWidth) * .5;
      const outputY = (outputHeight - inputHeight) * .5;
      const outputImage = document.createElement('canvas');

      outputImage.width = outputWidth
      outputImage.height = outputHeight;

      const ctx = outputImage.getContext('2d');
      ctx.drawImage(inputImage, outputX, outputY);

      var myImage = outputImage.toDataURL();

      resize(myImage, aspectRatio).then(canvas => {
        resolve(canvas);
      });
    };

    inputImage.src = url;
  })
}

function resize(url, ratio) {
  return new Promise(resolve => {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    const baseHeight = 640;
    canvas.width = baseHeight * ratio;
    canvas.height = baseHeight;

    var image = new Image();

    image.onload = function (e) {
      ctx.drawImage(image,
        0, 0, image.width, image.height,
        0, 0, canvas.width, canvas.height
      );
      var myImage = canvas.toDataURL();
      resolve(myImage);
    };

    image.src = url;
  })

}